import { removeObjectFromArray } from '../utils/arrayUtils';
import * as T from '../constants/types';

export const onCloseNotification = key => (dispatch, getState) => {
    const { notifications } = getState();
    const updatedNotifications = removeObjectFromArray(notifications, key, 'timeStamp');
    dispatch({ type: T.CLOSE_NOTIFICATION, payload: updatedNotifications });
};
